
export const ArrowRight = (props) => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.16675 10H15.8334"
            stroke="#FF9900"
            strokeWidth={1.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 4.16699L15.8333 10.0003L10 15.8337"
            stroke="#FF9900"
            strokeWidth={1.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
